/* eslint-disable @typescript-eslint/no-namespace */
import { HtmlUpdateWidgetController } from '../WidgetController';
export class HotEventsWidgetController extends HtmlUpdateWidgetController {
    private selectors = {
        tableCoef: '[j-result]',
        tableEvent: '.events-table__body-row',
        tableFavstar: '[j-favstar]',
    };

    protected install() {
        this.autoUpdate();
        this.bindUI();
    }
    protected beforeUpdate(): any {
        return this.collectCoefValues(this.getElement());
    }

    protected updateHtml(
        beforeUpdateData: any,
        html: any,
        successResponse: any
    ): void {
        const element = this.getElement();
        const actualCoefs = this.collectCoefValues(element);
        const events = $(element).find(this.selectors.tableEvent);

        if (window.BroadcastWidget) {
            if (window.BroadcastWidget.$store.state.Broadcast.isOpened) {
                events.each(function () {
                    const id = $(this).attr('data-id');

                    if (
                        window.BroadcastWidget.$store.state.Broadcast.event
                            .id == id
                    ) {
                        $(element)
                            .find(
                                '[broadcast-button][data-event-id=' + id + ']'
                            )
                            .addClass('m-active');
                    }
                });
            }
        }

        for (const originalId in actualCoefs) {
            const nodeCoef = $(
                this.selectors.tableCoef + '[data-oid=' + originalId + ']',
                element
            );

            const oldValue = beforeUpdateData[originalId];
            if (!isNaN(oldValue) && oldValue != undefined) {
                const newValue = actualCoefs[originalId];
                if (newValue != oldValue) {
                    const changeClass = newValue > oldValue ? 'plus' : 'minus';
                    nodeCoef.addClass(changeClass);
                    setTimeout(function () {
                        nodeCoef.removeClass(changeClass);
                    }, 3000);
                }
            }

            if (window.ClientCart.hasOutcome(Number(originalId))) {
                nodeCoef.addClass('active');
            }
        }
    }

    private bindUI() {
        const self = this;
        const selfNode = $(self.getElement());

        // удаление подсветки с кэфа, если он был удален из корзины через очистку корзины
        $(document).on(
            'deactivateCoefHightlight',
            function (event, originalId) {
                $('[data-oid=' + originalId + ']').removeClass('active');
            }
        );

        // добавление-удаление кэфа из корзины по клику
        selfNode.on('click', this.selectors.tableCoef, function () {
            self.addCoefToCart($(this));
        });

        selfNode.on('click', this.selectors.tableFavstar, function () {
            self.addToFavorites($(this));
        });
    }

    private addToFavorites(nodeFavstar: JQuery) {
        const nodeEvent = nodeFavstar.closest(this.selectors.tableEvent);
        const isRemovingFromFav = nodeFavstar.hasClass('m-active');
        const url =
            '/' +
            (nodeEvent.data('islive') ? 'Live' : 'Prematch') +
            '/' +
            (isRemovingFromFav ? 'UnFaveEvent' : 'FaveEvent');
        const allFavNodes = $(
            this.selectors.tableEvent + '[data-id=' + nodeEvent.data('id') + ']'
        ).find(this.selectors.tableFavstar);

        Ajax.postJson(url, {
            data: {
                id: nodeEvent.data('id'),
            },
            success: function (resp) {
                if (resp && resp.Message) {
                    nodeFavstar.removeClass('m-active');
                    // Выставим новый тултип для звезд + обновим работающий тултип
                    $(this.selectors.tableFavstar).attr(
                        'bb-tool',
                        resp.Tooltip
                    );
                    Tooltip.updateOpenedTooltipText(nodeFavstar, resp.Tooltip);
                    return;
                }
                allFavNodes.toggleClass('m-active');
            },
        });
    }

    private addCoefToCart(nodeCoef: JQuery) {
        if (nodeCoef.hasClass('m-empty')) {
            return;
        }

        const originalId = nodeCoef.data('oid');

        const cart = window.ClientCart;
        if (!cart) return;

        if (cart.hasOutcome(originalId)) {
            nodeCoef.removeClass('active');
            cart.removeOutcome(originalId);
        } else {
            const nodeEvent = nodeCoef.closest(this.selectors.tableEvent);
            cart.addOutcome({
                eId: Number(nodeEvent.attr('data-id')),
                oId: originalId,
            });
        }
    }

    private collectCoefValues(element: HTMLElement): any {
        const coefElements = $(
            this.selectors.tableCoef + '[data-oid]',
            element
        );
        const coefs = {};
        for (let i = 0; i < coefElements.length; i++) {
            const coefElement = $(coefElements[i]);
            const originalId = coefElement.attr('data-oid');
            if (originalId) {
                coefs[originalId] = parseFloat(
                    coefElement.attr('data-coefvalue')
                );
            }
        }

        return coefs;
    }
}
